import React, { useState, useEffect } from 'react';
import { Document, Packer, Header, Paragraph, HeightRule,TextRun, convertInchesToTwip,PageNumber,SimpleField,NumberFormat, Table, TableRow, Footer, TableCell, AlignmentType, WidthType, BorderStyle, ImageRun, VerticalAlign, VerticalPositionAlign, VerticalPositionRelativeFrom, HorizontalPositionAlign, HorizontalPositionRelativeFrom, TextWrappingType, } from "docx";
import { saveAs } from "file-saver";
import RelaysCTThree from "./RelaysCTThree";
import './RelaysCTFour.css';
import { API_URL } from "./API";


function RelaysCTFour({ savedGeneralData, goBack, updateFormData, createDataCell, formData, clearAllFormData }) {
  const functionalChecksData = [
    "Wiring checks",
    "Correct operation of appropriate indicator /aux. relay",
    "Correct intiation of alarm contacts",
    "Correct circuit breaker tripping contacts",
    "Relay cover properly fixing",
    "Correct operating reset switch",
    "Relay Draw out conditions CT shorting link should be short",
    "All Binary I/O's and LED indications Checked and found ok"
  ];

  const checkListData = [
    "Check the healthiness of fuses, links, MCCB, Switches, indication lamps, push buttons, space heater & illumination circuit",
    "Check broken glass, switch handle, lamp cover etc.",
    "Check all electrical interlock as per scheme.",
    "Check Mounting of all components i.e. Relays, Meters etc.",
    "Check the fuses for correct rating & mounting.",
    "Checking of breaker for free movement.",
    "Scheme checking as per approved drawings.",
    "Checking of all closing and tripping interlocks",
    "Checking of all contacts used for external system."
  ];

const [functionalValues, setFunctionalValues] = useState(() => {

  if (savedGeneralData?.functionalChecksData && Array.isArray(savedGeneralData.functionalChecksData)) {
    return savedGeneralData.functionalChecksData;
  }
  

  const savedFunctionalData = localStorage.getItem('functionalChecksData');
  if (savedFunctionalData) {
    try {
      const parsedData = JSON.parse(savedFunctionalData);
    
      if (parsedData && typeof parsedData === 'object' && !Array.isArray(parsedData)) {
        return functionalChecksData.map(check => parsedData[check] || "");
      }

      if (Array.isArray(parsedData) && parsedData.length === functionalChecksData.length) {
        return parsedData;
      }
    } catch (e) {
      
    }
  }
  

  return functionalChecksData.map(() => "");
});

const [checkListValues, setCheckListValues] = useState(() => {

  if (savedGeneralData?.checkListData && Array.isArray(savedGeneralData.checkListData)) {
    return savedGeneralData.checkListData;
  }
  
 
  const savedCheckListData = localStorage.getItem('checkListData');
  if (savedCheckListData) {
    try {
      const parsedData = JSON.parse(savedCheckListData);
      
      if (parsedData && typeof parsedData === 'object' && !Array.isArray(parsedData)) {
        return checkListData.map(check => parsedData[check] || "");
      }

      if (Array.isArray(parsedData) && parsedData.length === checkListData.length) {
        return parsedData;
      }
    } catch (e) {
      
    }
  }
  

  return checkListData.map(() => "");
});


  const [showBackPage, setShowBackPage] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [wordDocDownloaded, setWordDocDownloaded] = useState(false);
 
  
  const [projectDetails, setProjectDetails] = useState({
    subProjectName: "",
    categoryName: "",
    subcategoryName: "",
    equipmentName: "",
    projectId: "",
    location: ""
  });

  const [allFormData, setAllFormData] = useState({
    formData: {},
    rows: [],
    generalInspection: {},
    settings: {},
    operationalTimeData: {}
  });



  
  const ALL_STORAGE_KEYS = [
    'functionalChecksData',
    'checkListData',
    'relaysCTFormData',
    'relayCurrentMeasurements',
    'relayVoltageMeasurements',
    'relaySettings',
    'relaysCTRowsData',
    'relayTestData',
    'relaysCTGeneralInspection',
    'relaysCTSettings',
    'relaysCTOperationalTime',
    'createReportData',
    'navbarData',
    'relaysCTInspectionReportWord',
    'relaysCT_autosave',
    'relayTestReportWord',
    'formSubmissionStatus',
    'wordDocDownloadStatus',
    'reportCreationCompleted', 
    'lastCompletionTimestamp'   
  ];

const clearAllStorageData = () => {
  try {
    
    
    ALL_STORAGE_KEYS.forEach(key => {
      localStorage.removeItem(key);
    });
    
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && (key.toLowerCase().includes('relay') || 
                  key.toLowerCase().includes('ct') || 
                  key.toLowerCase().includes('form') || 
                  key.toLowerCase().includes('test') || 
                  key.toLowerCase().includes('report'))) {
        keysToRemove.push(key);
      }
    }
    
    keysToRemove.forEach(key => localStorage.removeItem(key));
    
    
    return true;
  } catch (error) {
   
    return false;
  }
};

  const resetAllFormStates = () => {
    
    
    setFunctionalValues(functionalChecksData.map(() => ""));
    setCheckListValues(checkListData.map(() => ""));
    
    setProjectDetails({
      subProjectName: "",
      categoryName: "",
      subcategoryName: "",
      equipmentName: "",
      projectId: "",
      location: ""
    });

    setAllFormData({
      formData: {},
      rows: [],
      generalInspection: {},
      settings: {},
      operationalTimeData: {}
    });

    setFormSubmitted(false);
    setWordDocDownloaded(false);
    setErrorMessage("");
    setSuccessMessage("");
    setShowBackPage(false);
    
    if (clearAllFormData && typeof clearAllFormData === 'function') {
      try {
        clearAllFormData();
       
      } catch (error) {
      
      }
    }
    
   
  };

  
  const performCompleteCleanup = () => {
   
    
    try {
      localStorage.setItem('reportCreationCompleted', 'true');
      localStorage.setItem('lastCompletionTimestamp', Date.now().toString());
    } catch (error) {
    
    }
    
    clearAllStorageData();
    resetAllFormStates();
    
    
   
  };

  const hasCompletedFullFlow = () => {
    const submitted = formSubmitted;
    const downloaded = wordDocDownloaded;
    const completionFlag = localStorage.getItem('reportCreationCompleted') === 'true';
    
    return submitted && downloaded || completionFlag;
  };

  const checkForCompletedSession = () => {
    try {
      const submissionStatus = localStorage.getItem('formSubmissionStatus');
      const downloadStatus = localStorage.getItem('wordDocDownloadStatus');
      const completionFlag = localStorage.getItem('reportCreationCompleted');
      const lastCompletion = localStorage.getItem('lastCompletionTimestamp');
      
      const recentCompletion = lastCompletion && 
        (Date.now() - parseInt(lastCompletion)) < 5 * 60 * 1000;
      
      const shouldClear = (
        (submissionStatus === 'completed' && downloadStatus === 'completed') ||
        (completionFlag === 'true') ||
        recentCompletion
      );
      
      if (shouldClear) {
        
        performCompleteCleanup();
        return true;
      }
      
      return false;
    } catch (error) {
      
      return false;
    }
  };

const loadDataFromStorage = () => {
  if (checkForCompletedSession()) {
    return; 
  }
  
  try {
   
    

    if (savedGeneralData?.functionalChecksData) {
     
      if (Array.isArray(savedGeneralData.functionalChecksData)) {
        setFunctionalValues(savedGeneralData.functionalChecksData);
      } else if (typeof savedGeneralData.functionalChecksData === 'object') {
        setFunctionalValues(functionalChecksData.map(check => 
          savedGeneralData.functionalChecksData[check] || ""
        ));
      }
    } else {
      const savedFunctionalData = localStorage.getItem('functionalChecksData');
      if (savedFunctionalData) {
        const parsedFunctionalData = JSON.parse(savedFunctionalData);
        if (Array.isArray(parsedFunctionalData) && parsedFunctionalData.length === functionalChecksData.length) {
          setFunctionalValues(parsedFunctionalData);
        } else if (typeof parsedFunctionalData === 'object') {
          setFunctionalValues(functionalChecksData.map(check => 
            parsedFunctionalData[check] || ""
          ));
        }
      }
    }


    if (savedGeneralData?.checkListData) {
     
      if (Array.isArray(savedGeneralData.checkListData)) {
        setCheckListValues(savedGeneralData.checkListData);
      } else if (typeof savedGeneralData.checkListData === 'object') {
        setCheckListValues(checkListData.map(check => 
          savedGeneralData.checkListData[check] || ""
        ));
      }
    } else {
      const savedCheckListData = localStorage.getItem('checkListData');
      if (savedCheckListData) {
        const parsedCheckListData = JSON.parse(savedCheckListData);
        if (Array.isArray(parsedCheckListData) && parsedCheckListData.length === checkListData.length) {
          setCheckListValues(parsedCheckListData);
        } else if (typeof parsedCheckListData === 'object') {
          setCheckListValues(checkListData.map(check => 
            parsedCheckListData[check] || ""
          ));
        }
      }
    }


    if (savedGeneralData?.operationalTimeData && Object.keys(savedGeneralData.operationalTimeData).length > 0) {
      
      setAllFormData(prev => ({
        ...prev,
        operationalTimeData: savedGeneralData.operationalTimeData
      }));
    } else {
      const savedOpData = localStorage.getItem('relayCTOperationalTimeData');
      if (savedOpData) {
        const parsedOpData = JSON.parse(savedOpData);
        setAllFormData(prev => ({
          ...prev,
          operationalTimeData: parsedOpData
        }));
      }
    }

    const localNavbarData = localStorage.getItem('navbarData'); 
    const localProjectData = localStorage.getItem('createReportData');
    
    if (localNavbarData) {
      const parsedNavbarData = JSON.parse(localNavbarData);
      if (parsedNavbarData.location) {
        setProjectDetails(prev => ({
          ...prev,
          location: parsedNavbarData.location
        }));
      }
    }
  
    if (localProjectData) {
      const parsedProjectData = JSON.parse(localProjectData);
      setProjectDetails({
        subProjectName: parsedProjectData.sub_project_name || "",
        categoryName: parsedProjectData.category_name || "",
        subcategoryName: parsedProjectData.subcategory_name || "",
        equipmentName: parsedProjectData.equipment_name || "",
        projectId: parsedProjectData.project_id || "",
        location: parsedProjectData.location || (localNavbarData ? JSON.parse(localNavbarData).location || "" : "")
      });
    }
    
    
  } catch (error) {
    
  }
};


  useEffect(() => {
   
    
    if (!checkForCompletedSession()) {
      loadDataFromStorage();
    }
  }, []); 

  useEffect(() => {
    if (hasCompletedFullFlow()) {
   
      return; 
    }

    const autoSave = () => {
      try {
        const formDataToSave = {
          functionalValues: functionalValues,
          checkListValues: checkListValues,
          projectDetails: projectDetails,
          timestamp: new Date().toISOString()
        };
        localStorage.setItem('relaysCT_autosave', JSON.stringify(formDataToSave));
      
      } catch (error) {
      
      }
    };

    const autoSaveInterval = setInterval(autoSave, 30000);
    return () => clearInterval(autoSaveInterval);
  }, [functionalValues, checkListValues, projectDetails, formSubmitted, wordDocDownloaded]);

  useEffect(() => {
    if (!hasCompletedFullFlow()) {
      try {
        localStorage.setItem('functionalChecksData', JSON.stringify(functionalValues));
      } catch (error) {
        
      }
    }
  }, [functionalValues, formSubmitted, wordDocDownloaded]);

  useEffect(() => {
    if (!hasCompletedFullFlow()) {
      try {
        localStorage.setItem('checkListData', JSON.stringify(checkListValues));
      } catch (error) {
        
      }
    }
  }, [checkListValues, formSubmitted, wordDocDownloaded]);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (hasCompletedFullFlow()) {
        
        clearAllStorageData();
      }
    };

    const handleUnload = () => {
      if (hasCompletedFullFlow()) {
        clearAllStorageData();
      }
    };

    const handleVisibilityChange = () => {
      if (document.hidden && hasCompletedFullFlow()) {
        
        clearAllStorageData();
      }
    };

    const handleFocus = () => {
      if (checkForCompletedSession()) {
        
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('unload', handleUnload);
    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('focus', handleFocus);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('unload', handleUnload);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('focus', handleFocus);
    };
  }, [formSubmitted, wordDocDownloaded]);

  const handleFunctionalChange = (index, value) => {
    if (hasCompletedFullFlow()) {
     
      return; 
    }
    
    const newValues = [...functionalValues];
    newValues[index] = value;
    setFunctionalValues(newValues);
    
    try {
      localStorage.setItem('functionalChecksData', JSON.stringify(newValues));
    } catch (error) {
     
    }
  };

  const handleCheckListChange = (index, value) => {
    if (hasCompletedFullFlow()) {
     
      return;
    }
    
    const newValues = [...checkListValues];
    newValues[index] = value;
    setCheckListValues(newValues);
    
    try {
      localStorage.setItem('checkListData', JSON.stringify(newValues));
    } catch (error) {
      
    }
  };

const redirectToHome = () => {
  if (window.confirm("Are you sure you want to leave this page")) {  
    localStorage.setItem('openReportsOnLoad', 'true');
    window.location.href = "/";
  }
};


  const createSimpleDictionary = (dataArray, descriptionsArray) => {
    const dictionary = {};
    
    dataArray.forEach((value, index) => {
      if (index < descriptionsArray.length) {
        const description = descriptionsArray[index];
        dictionary[description] = value || "";
      }
    });
    
    return dictionary;
  };

const handleSave = async (e) => {
  e.preventDefault();
  setFormSubmitted(true);
  setIsLoading(true);
  setErrorMessage("");
 
  try {
    localStorage.setItem('formSubmissionStatus', 'in_progress');
   
    const functionalChecksDict = createSimpleDictionary(functionalValues, functionalChecksData);
    const checkListDict = createSimpleDictionary(checkListValues, checkListData);
 
  
 
    localStorage.setItem('functionalChecksData', JSON.stringify(functionalChecksDict));
    localStorage.setItem('checkListData', JSON.stringify(checkListDict));
 
    const loadFormDataSafely = (key, defaultValue = {}) => {
      try {
        const data = localStorage.getItem(key);
        return data ? JSON.parse(data) : defaultValue;
      } catch (error) {
       
        return defaultValue;
      }
    };
 
    const formData = loadFormDataSafely('relayTestData', {});
    const currentData = loadFormDataSafely('relayCurrentMeasurements', {});
    const voltageData = loadFormDataSafely('relayVoltageMeasurements', {});
    const settingsData = loadFormDataSafely('relaySettings', {});
    const operationalTimeData = loadFormDataSafely('relayCTOperationalTimeData', {});
    const navbarData = loadFormDataSafely('navbarData', {});
 
   const testLocation = String(formData.location || projectDetails.location || navbarData.location || "");
 
    const convertArrayToDict = (data) => {
      const convertedData = {};
     
      for (const [key, value] of Object.entries(data)) {
        if (Array.isArray(value)) {
          convertedData[key] = {};
          value.forEach((item, index) => {
            if (typeof item === 'object' && item !== null) {
              for (const [subKey, subValue] of Object.entries(item)) {
                if (!convertedData[key][subKey]) {
                  convertedData[key][subKey] = {};
                }
                convertedData[key][subKey][`reading_${index + 1}`] = subValue;
              }
            } else {
              convertedData[key][`reading_${index + 1}`] = item;
            }
          });
        } else if (typeof value === 'object' && value !== null) {
          convertedData[key] = convertArrayToDict(value);
        } else {
          convertedData[key] = value;
        }
      }
     
      return convertedData;
    };
 
    const convertedFormData = convertArrayToDict(formData || {});
    const convertedCurrentData = convertArrayToDict(currentData || {});
    const convertedVoltageData = convertArrayToDict(voltageData || {});
    const convertedSettingsData = convertArrayToDict(settingsData || {});
    const convertedOperationalTimeData = convertArrayToDict(operationalTimeData || {});
 
    
 
    const wordBlob = await generateWordBlob();
   
    if (!wordBlob) {
      throw new Error("Failed to generate Word document");
    }
   
    const reader = new FileReader();
    reader.readAsDataURL(wordBlob);
   
  reader.onloadend = async () => {
  try {
    const base64data = reader.result;
   
    if (!base64data) {
      throw new Error("Failed to convert Word document to base64");
    }
   
    localStorage.setItem('relayTestReportWord', base64data);
   
    const currentDate = new Date().toISOString().split('T')[0];
   
    const getProjectId = () => {
     
     
      if (savedGeneralData?.projectData?.project_id) {
        const id = parseInt(savedGeneralData.projectData.project_id);
        if (!isNaN(id) && id > 0) {
         
          return id;
        }
      }
      
     
      if (projectDetails.projectId) {
        const id = parseInt(projectDetails.projectId);
        if (!isNaN(id) && id > 0) {
          
          return id;
        }
      }
      
     
      try {
        const createReportData = localStorage.getItem('createReportData');
        if (createReportData) {
          const parsedData = JSON.parse(createReportData);
        
         
          if (parsedData.project_id) {
            const id = parseInt(parsedData.project_id);
            if (!isNaN(id) && id > 0) {
              
              return id;
            }
          }
        }
      } catch (error) {
       
      }
     
     
      if (convertedFormData.project_id) {
        const id = parseInt(convertedFormData.project_id);
        if (!isNaN(id) && id > 0) {
   
          return id;
        }
      }
      if (convertedFormData.reportNo) {
        const id = parseInt(String(convertedFormData.reportNo).replace(/\D/g, ''));
        if (!isNaN(id) && id > 0) {
          
          return id;
        }
      }
     
     
      throw new Error("Unable to determine project ID. Please ensure project is properly selected.");
    };
   
    const projectId = getProjectId();
  
   const apiRequestData = {
  equipment_name: String(projectDetails.equipmentName || convertedFormData.equipment || "Relays CT Equipment"),
  test_date: String(convertedFormData.date || currentDate),
  category_name: String(projectDetails.categoryName || "Category"),
  subcategory_name: String(projectDetails.subcategoryName || "Subcategory"),
  sub_project_name: String(projectDetails.subProjectName || convertedFormData.project || "Project"),
  project_id: projectId,
  location: testLocation, 
  report_file: {  
    report_word: base64data,
    filename: `RelaysCT_Test_Report_${Date.now()}.docx`,
    file_type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  },
  test_data: {
    a_formData: convertedFormData || {},
    b_currentData: convertedCurrentData || {},
    c_voltageData: convertedVoltageData || {},
    d_settingsData: convertedSettingsData || {},
    e_operationalTimeData: convertedOperationalTimeData || {},
    f_functionalChecksData: functionalChecksDict || {},
    g_checkListData: checkListDict || {}
  }
};

  

    const response = await fetch(`${API_URL}/test_report/create_test_report`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(apiRequestData),
      mode: 'cors',
      credentials: 'same-origin',
    });

    if (!response.ok) {
      let errorData;
      try {
        errorData = await response.json();
        
      } catch (jsonError) {
      
        errorData = { message: response.statusText };
      }
     
      throw new Error(`API error: ${response.status} - ${errorData.message || errorData.detail || response.statusText}`);
    }

    const result = await response.json();
   

   
    localStorage.setItem('formSubmissionStatus', 'completed');
    setSuccessMessage("Data submitted successfully");
     
    alert("Data Submitted successfully");
   
  } catch (error) {

    localStorage.setItem('formSubmissionStatus', 'failed');
    setErrorMessage(`Error: ${error.message}`);
  } finally {
    setIsLoading(false);
  }
};

    reader.onerror = (error) => {
     
      localStorage.setItem('formSubmissionStatus', 'failed');
      setIsLoading(false);
      setErrorMessage("Error reading Word document file");
    };
   
  } catch (error) {
   
    localStorage.setItem('formSubmissionStatus', 'failed');
   
    if (error.message.includes("Failed to fetch")) {
      setErrorMessage("Cannot connect to server. Please check if the backend is running.");
    } else if (error.message.includes("generateWordBlob is not defined")) {
      setErrorMessage("Word document generation function is missing. Please check your imports.");
    } else if (error.message.includes("Unable to determine project ID")) {
      setErrorMessage(error.message);
      alert(error.message);
    } else {
      setErrorMessage(`Error: ${error.message}`);
    }
    setIsLoading(false);
  }
};
 

const generateWordBlob = () => {
  return new Promise((resolve, reject) => {
    try {
     
      const operationalTimeData = JSON.parse(localStorage.getItem('relayCTOperationalTimeData') || '{}');
      const settingsData = JSON.parse(localStorage.getItem('relaySettings') || '{}');
      const currentMeasurements = JSON.parse(localStorage.getItem('relayCurrentMeasurements') || '{}');
      const voltageMeasurements = JSON.parse(localStorage.getItem('relayVoltageMeasurements') || '{}');
      const storedFormData = JSON.parse(localStorage.getItem('relayTestData') || '{}');

   
      const tableBorders = {
        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
      };

      
      function findValue(data, searchTerms, defaultValue = "N/A") {
        if (!data || typeof data !== 'object') return defaultValue;
        
        const terms = Array.isArray(searchTerms) ? searchTerms : [searchTerms];
        
        for (let term of terms) {
          if (data[term] !== undefined && data[term] !== null && data[term] !== '') {
            return data[term];
          }
        }
        
        const dataKeys = Object.keys(data);
        for (let term of terms) {
          const termLower = term.toLowerCase();
          for (let key of dataKeys) {
            if (key.toLowerCase() === termLower && data[key] !== undefined && data[key] !== null && data[key] !== '') {
              return data[key];
            }
          }
        }
        
        for (let term of terms) {
          const termLower = term.toLowerCase();
          for (let key of dataKeys) {
            if (key.toLowerCase().includes(termLower) && data[key] !== undefined && data[key] !== null && data[key] !== '') {
              return data[key];
            }
          }
        }
        
        return defaultValue;
      }

      function safeToString(value) {
        if (value === null || value === undefined || value === '' || value === 'N/A') {
          return "";
        }
        return value.toString();
      }

      function safeGetValue(obj, keys, defaultValue = 'N/A') {
        if (!obj || typeof obj !== 'object') return defaultValue;
      
        const keyList = Array.isArray(keys) ? keys : [keys];
      
        for (let key of keyList) {
        
          if (key.includes('.')) {
            const parts = key.split('.');
            let value = obj;
            for (let part of parts) {
              if (value && typeof value === 'object' && part in value) {
                value = value[part];
              } else {
                value = undefined;
                break;
              }
            }
            if (value !== undefined && value !== null && value !== '') {
              return value.toString();
            }
          }
      
         
          if (obj[key] !== undefined && obj[key] !== null && obj[key] !== '') {
            return obj[key].toString();
          }
      
         
          const lowerKey = key.toLowerCase();
          for (let objKey in obj) {
            if (objKey.toLowerCase() === lowerKey) {
              const val = obj[objKey];
              if (val !== undefined && val !== null && val !== '') {
                return val.toString();
              }
            }
          }
        }
      
        return defaultValue;
      }

      const getCurrentValue = (phase, type) => {
        const phaseKey = phase?.toUpperCase(); 
        const typeKey = type?.toLowerCase();   
      
        if (
          currentMeasurements[phaseKey] &&
          currentMeasurements[phaseKey][typeKey]
        ) {
          return currentMeasurements[phaseKey][typeKey].toString();
        }
      
        return 'N/A';
      };

      const getVoltageValue = (phase, type) => {
        const phaseKey = phase?.toUpperCase();  
        const typeKey = type?.toLowerCase();   
      
        if (
          voltageMeasurements[phaseKey] &&
          voltageMeasurements[phaseKey][typeKey]
        ) {
          return voltageMeasurements[phaseKey][typeKey].toString();
        }
      
        return 'N/A';
      };

     
      const getSettingValue = (element, parameter) => {
        const elementKey = element.toLowerCase().replace(/[\/\s]/g, '');
        const parameterKey = parameter.toLowerCase().replace(/\s/g, '');
      
        if (
          settingsData[element] &&
          settingsData[element][parameter]
        ) {
          return settingsData[element][parameter].toString();
        }
      
        const keyOptions = [
          `${element}_${parameter}`,
          `${element}${parameter}`,
          `${elementKey}_${parameterKey}`,
          `${elementKey}${parameterKey}`,
          `${element} ${parameter}`
        ];
      
        const settingValue = safeGetValue(settingsData, keyOptions);
        if (settingValue !== "N/A") return settingValue;
      
        return safeGetValue(storedFormData, keyOptions);
      };

      function getBasicValue(sectionData, fieldSearchTerms, phase) {
        if (!sectionData) return "N/A";
        
     
        const phaseSpecificValue = findValue(sectionData, [
          `${fieldSearchTerms[0]}_${phase}`,
          `${fieldSearchTerms[0]}${phase}`,
          `${phase}_${fieldSearchTerms[0]}`,
          `${phase}${fieldSearchTerms[0]}`
        ]);
        
        if (phaseSpecificValue !== "N/A") return phaseSpecificValue;
        
       
        return findValue(sectionData, fieldSearchTerms);
      }

      function getInjectedFromIndex(data, phase, multiplier) {
        if (!data) return 'N/A';
        
        const fieldMap = {
          '2X': 'injectedCurrent2X',
          '5X': 'injectedCurrent5X',
          '10X': 'injectedCurrent10X'
        };
        
        const fieldName = fieldMap[multiplier];
        if (fieldName && data[fieldName] !== undefined && data[fieldName] !== null && data[fieldName] !== '') {
          return data[fieldName];
        }
        
        return 'N/A';
      }

     
      function getOperatedFromIndex(data, phase, multiplier) {
        if (!data) return 'N/A';
        
        
        const fieldMap = {
          '2X': 'operatedTime2X',
          '5X': 'operatedTime5X',
          '10X': 'operatedTime10X'
        };
        
        const fieldName = fieldMap[multiplier];
        if (fieldName && data[fieldName] !== undefined && data[fieldName] !== null && data[fieldName] !== '') {
          return data[fieldName];
        }
        
        return 'N/A';
      }

    
      let sectionDataOC1 = operationalTimeData['oc1'] || operationalTimeData['OC1'] || operationalTimeData['O/C 1'] || {};
      let sectionDataOC2 = operationalTimeData['oc2'] || operationalTimeData['OC2'] || operationalTimeData['O/C 2'] || {};
      let sectionDataEF1 = operationalTimeData['ef1'] || operationalTimeData['EF1'] || operationalTimeData['E/F 1'] || {};
      let sectionDataEF2 = operationalTimeData['ef2'] || operationalTimeData['EF2'] || operationalTimeData['E/F 2'] || {};
      let sectionDataUV1 = operationalTimeData['uv1'] || operationalTimeData['UV1'] || operationalTimeData['U/V 1'] || {};
      let sectionDataUV2 = operationalTimeData['uv2'] || operationalTimeData['UV2'] || operationalTimeData['U/V 2'] || {};
      let sectionDataOV1 = operationalTimeData['ov1'] || operationalTimeData['OV1'] || operationalTimeData['O/V 1'] || {};
      let sectionDataOV2 = operationalTimeData['ov2'] || operationalTimeData['OV2'] || operationalTimeData['O/V 2'] || {};

     
      const fetchImageAsBase64 = (url) => {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.crossOrigin = 'anonymous';
          img.onload = function() {
            try {
              const canvas = document.createElement('canvas');
              const ctx = canvas.getContext('2d');
              canvas.width = img.width;
              canvas.height = img.height;
              ctx.drawImage(img, 0, 0);
              const dataURL = canvas.toDataURL('image/png');
              const base64 = dataURL.split(',')[1];
              resolve(base64);
            } catch (error) {
            
              resolve(null);
            }
          };
          img.onerror = function() {
           
            resolve(null);
          };
          img.src = url;
        });
      };

     
      const documentSections = [];

     

       const createLightWatermark = (base64Data, color ="#1e402c") => {
        return new Promise((resolve) => {
          if (!base64Data) {
            resolve(null);
            return;
          }
          
          try {
            const img = new Image();
            img.onload = function() {
              const canvas = document.createElement('canvas');
              const ctx = canvas.getContext('2d');
              canvas.width = img.width;
              canvas.height = img.height;
              
             
              ctx.globalAlpha = 0.15; 
              ctx.drawImage(img, 0, 0);
              
              const lightDataURL = canvas.toDataURL('image/png');
              const lightBase64 = lightDataURL.split(',')[1];
              resolve(lightBase64);
            };
            img.onerror = function() {
              resolve(null);
            };
            img.src = 'data:image/png;base64,' + base64Data;
          } catch (error) {
           
            resolve(null);
          }
        });
      };

      
      

      
      const logoUrl = "https://i.ibb.co/BHKCMXV8/Whats-App-Image-2025-06-16-at-11-21-26-AM.jpg";
      const watermarkUrl = "https://i.ibb.co/BHKCMXV8/Whats-App-Image-2025-06-16-at-11-21-26-AM.jpg"; 
 

      
      Promise.all([
        fetchImageAsBase64(logoUrl),
        fetchImageAsBase64(watermarkUrl)
      ]).then(([logoBase64, watermarkBase64]) => {
        
       
        createLightWatermark(watermarkBase64, "#1e402c").then((lightWatermarkBase64) => {
        
        
      
        const headerElements = [];

        if (logoBase64) {
          headerElements.push(
            new Table({
              width: { size: 100, type: WidthType.PERCENTAGE },
              rows: [
                new TableRow({
                  children: [
                    new TableCell({
                      children: [
                        new Paragraph({
                          children: [
                            new ImageRun({
                              data: logoBase64,
                              transformation: {
                                width: 80,
                                height: 80
                              }
                            })
                          ],
                          alignment: AlignmentType.CENTER,
                        })
                      ],
                      verticalAlign: VerticalAlign.CENTER,
                      borders: {
                        top: { style: BorderStyle.SINGLE, size: 1 },
                        bottom: { style: BorderStyle.SINGLE, size: 1 },
                        left: { style: BorderStyle.SINGLE, size: 1 },
                        right: { style: BorderStyle.SINGLE, size: 1 }
                      },
                      width: { size: 20, type: WidthType.PERCENTAGE },
                      margins: {
                        top: 0,
                        bottom: 0,
                        left: 0,
                        right: 0
                      }
                    }),
                    new TableCell({
                      children: [
                        new Paragraph({
                          children: [
                            new TextRun({
                              text: "PIE POWER PRIVATE LIMITED",
                              font: "Times New Roman",
                              color:"#1e402c",
                              bold: true,
                              size: 36
                            })
                          ],
                          alignment: AlignmentType.CENTER
                        }),
                        new Paragraph({
                          children: [
                            new TextRun({
                              text: "VISAKHAPATNAM, ANDHRA PRADESH, INDIA-531163",
                              font: "helvetica",
                              size: 20
                            })
                          ],
                          alignment: AlignmentType.CENTER
                        }),
                        new Paragraph({
                          children: [
                            new TextRun({
                              text: "Email: info@piepower.in, Web: piepower.in, Contact: +91 8186084709",
                              font: "helvetica",
                              size: 20
                            })
                          ],
                          alignment: AlignmentType.CENTER
                        })
                      ],
                      borders: {
                        top: { style: BorderStyle.SINGLE, size: 1 },
                        bottom: { style: BorderStyle.SINGLE, size: 1 },
                        left: { style: BorderStyle.SINGLE, size: 1 },
                        right: { style: BorderStyle.SINGLE, size: 1 }
                      },
                      width: { size: 80, type: WidthType.PERCENTAGE }
                    })
                  ]
                })
              ]
            })
          );
        } else {
          
          headerElements.push(
            new Paragraph({
              children: [
                new TextRun({
                  text: "PIE POWER PRIVATE LIMITED",
                  font: "Times New Roman",
                  color:"#1e402c",
                  bold: true,
                  size: 36
                })
              ],
              alignment: AlignmentType.CENTER
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: "VISAKHAPATNAM, ANDHRA PRADESH, INDIA-531163",
                  font: "helvetica",
                  size: 20
                })
              ],
              alignment: AlignmentType.CENTER
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: "Email: info@piepower.in, Web: piepower.in, Contact: +91 8186084709",
                  font: "helvetica",
                  size: 20
                })
              ],
              alignment: AlignmentType.CENTER
            })
          );
        }

        headerElements.push(new Paragraph({ text: "" })); 
        documentSections.push(...headerElements);

      
        documentSections.push(
          new Table({
            width: { size: 100, type: WidthType.PERCENTAGE },
            rows: [
              new TableRow({
                children: [
                  new TableCell({ 
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:   "Description", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    width: { size: 20, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({ 
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "RELAYS INSPECTION / TEST REPORT", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    width: { size: 50, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({ 
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:    "Date", font: "Courier New" , bold: true })] })],
                    borders: tableBorders,
                    width: { size: 15, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({ 
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:    safeToString(storedFormData?.date), font: "Courier New" })] })],
                    borders: tableBorders,
                    width: { size: 15, type: WidthType.PERCENTAGE }
                  })
                ]
              }),
              new TableRow({
                children: [
                  new TableCell({ 
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:    "Project", font: "Courier New", bold: true })] })],
                    borders: tableBorders
                  }),
                  new TableCell({ 
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:    safeToString(storedFormData?.project), font: "Courier New", bold: true })] })],
                    borders: tableBorders
                  }),
                  new TableCell({  
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:   "Report No", font: "Courier New", bold: true  })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({  alignment: AlignmentType.CENTER, children: [new TextRun({ text:    safeToString(storedFormData?.reportNo), font: "Courier New" })] })],
                    borders: tableBorders
                  })
                ]
              }),
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({  alignment: AlignmentType.CENTER, children: [new TextRun({ text:    "Customer", font: "Courier New", bold: true })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER,  children: [new TextRun({ text:    safeToString(storedFormData?.customer), font: "Courier New", bold: true })] })],
                    borders: tableBorders
                  }),
                
                  new TableCell({
                    children: [new Paragraph({ children: [new TextRun({ text:  " " , font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                   new TableCell({
                    children: [new Paragraph({ children: [new TextRun({ text:  " " , font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                ]
              }),
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER,  children: [new TextRun({ text:    "Client", font: "Courier New", bold: true })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({  alignment: AlignmentType.CENTER, children: [new TextRun({ text:    safeToString(storedFormData?.client), font: "Courier New", bold: true })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ children: [new TextRun({ text:  "", font: "Courier New", bold: true })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ children: [new TextRun({ text:  "", font: "Courier New" })] })],
                    borders: tableBorders
                  })
                ]
              })
            ]
          })
        );

        documentSections.push(new Paragraph({ text: "" })); 

               
        
              documentSections.push(
                  new Paragraph({
                    children: [
                      new TextRun({
                        
                        text: "LOCATION:",
                        font: "Courier New",
                         bold: true,
                        size: 24
                      }),
                       new TextRun({
                        text: " " + safeToString(storedFormData?.location),
                        font: "Courier New",
                      
                        size: 24
                      })
                    ]
                  })
                );
        
                documentSections.push(new Paragraph({ text: "" })); 
        
       
        documentSections.push(
          new Paragraph({
            children: [
              new TextRun({
                text: "Name Plate Details",
                text: "NAME PLATE DETAILS",
                font: "Courier New",
                bold: true,
                size: 24
              })
            ]
          })
        );

       
        const nameplateFields = [
          

          { label: "Make", value: storedFormData?.make },
          { label: "Type", value: storedFormData?.type },
          { label: "Serial No", value: storedFormData?.serialNo },
          { label: "Supply Voltage(Uaux)", value: storedFormData?.supplyVoltage },
          { label: "CT Ratio", value: storedFormData?.ctRatio },
          { label: "VT Ratio", value: storedFormData?.vtRatio }
        ];

        const nameplateRows = [];

        nameplateFields.forEach(field => {
          nameplateRows.push(
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER,  children: [new TextRun({ text:    field.label, font: "Courier New", bold: true })] })],
                  borders: tableBorders,
                   width: { size: 50, type: WidthType.PERCENTAGE },
                  shading: {
              fill: "a6a6a6" 
            }
                }),
                new TableCell({
                  children: [new Paragraph({  alignment: AlignmentType.CENTER, children: [new TextRun({ text:    safeToString(field.value), font: "Courier New" })] })],
                  borders: tableBorders,
                   width: { size: 50, type: WidthType.PERCENTAGE }
                })
              ]
            })
          );
        });

        documentSections.push(
          new Table({
            width: { size: 100, type: WidthType.PERCENTAGE },
            rows: nameplateRows
          })
        );

        documentSections.push(new Paragraph({ text: "" }));

      
        documentSections.push(
          new Paragraph({
            children: [
              new TextRun({
                text: "MEASUREMENTS : Current",
                font: "Courier New",
                bold: true,
                size: 24
              })
            ]
          })
        );

       
        documentSections.push(
          new Table({
            width: { size: 100, type: WidthType.PERCENTAGE },
            rows: [
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Phase", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    width: { size: 20, type: WidthType.PERCENTAGE },
                    shading: {
                      fill: "a6a6a6" 
                    }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Injected Current(Amp)", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                    fill: "a6a6a6" 
                  },
                    width: { size: 40, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Measured Current(Amp)", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                    fill: "a6a6a6" 
                  },
                    width: { size: 40, type: WidthType.PERCENTAGE }
                  })
                ]
              }),
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "R", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: { fill: "a6a6a6" }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getCurrentValue('R', 'Injected'), font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getCurrentValue('R', 'Measured'), font: "Courier New" })] })],
                    borders: tableBorders
                  })
                ]
              }),
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Y", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: { fill: "a6a6a6" }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getCurrentValue('Y', 'Injected'), font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getCurrentValue('Y', 'Measured'), font: "Courier New" })] })],
                    borders: tableBorders
                  })
                ]
              }),
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "B", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                    fill: "a6a6a6" 
                  },
                   
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getCurrentValue('B', 'Injected'), font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getCurrentValue('B', 'Measured'), font: "Courier New" })] })],
                    borders: tableBorders
                  })
                ]
              })
            ]
          })
        );

        documentSections.push(new Paragraph({ text: "" })); 

     
        documentSections.push(
          new Paragraph({
            children: [
              new TextRun({
                text: "MEASUREMENTS : Voltage",
                font: "Courier New",
                bold: true,
                size: 24
              })
            ]
          })
        );

       
        documentSections.push(
          new Table({
            width: { size: 100, type: WidthType.PERCENTAGE },
            rows: [
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Phase", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    width: { size: 20, type: WidthType.PERCENTAGE },
                    shading: {
                      fill: "a6a6a6" 
                    }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Injected Voltage(V)", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                    fill: "a6a6a6" 
                  },
                    width: { size: 40, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Measured Voltage(KV)", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                    fill: "a6a6a6" 
                  },
                    width: { size: 40, type: WidthType.PERCENTAGE }
                  })
                ]
              }),
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "R", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: { fill: "a6a6a6" }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getVoltageValue('R', 'Injected'), font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getVoltageValue('R', 'Measured'), font: "Courier New" })] })],
                    borders: tableBorders
                  })
                ]
              }),
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Y", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: { fill: "a6a6a6" }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getVoltageValue('Y', 'Injected'), font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getVoltageValue('Y', 'Measured'), font: "Courier New" })] })],
                    borders: tableBorders
                  })
                ]
              }),
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "B", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                    fill: "a6a6a6" 
                  },
                  
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getVoltageValue('B', 'Injected'), font: "Courier New" })] })],
                    borders: tableBorders,
                   
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getVoltageValue('B', 'Measured'), font: "Courier New" })] })],
                    borders: tableBorders,
                    
                  })
                ]
              })
            ]
          })
        );

        documentSections.push(new Paragraph({ alignment: AlignmentType.CENTER, text: "" })); 

      
        documentSections.push(
          new Paragraph({
            children: [
              new TextRun({
                text: "RELAY SETTINGS",
                font: "Courier New",
                bold: true,
                size: 24
              })
            ]
          })
        );

      
        documentSections.push(
          new Table({
            width: { size: 100, type: WidthType.PERCENTAGE },
            rows: [
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Parameter", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    width: { size: 14, type: WidthType.PERCENTAGE },
                    shading: {
                      fill: "a6a6a6" 
                    }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "O/C 1", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                    fill: "a6a6a6" 
                  },
                    width: { size:10.75, type: WidthType.PERCENTAGE }
                }),
                new TableCell({
                    children: [new Paragraph({alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "O/C 2", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                    fill: "a6a6a6" 
                  },
                    width: { size: 10.75, type: WidthType.PERCENTAGE }
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "E/F 1", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                    fill: "a6a6a6" 
                  },
                    width: { size: 10.75, type: WidthType.PERCENTAGE }
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "E/F 2", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                    fill: "a6a6a6" 
                  },
                    width: { size: 10.75, type: WidthType.PERCENTAGE }
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "U/V 1", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                    fill: "a6a6a6" 
                  },
                    width: { size: 10.75, type: WidthType.PERCENTAGE }
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "U/V 2", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                    fill: "a6a6a6" 
                  },
                    width: { size: 10.75, type: WidthType.PERCENTAGE }
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "O/V 1", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                    fill: "a6a6a6" 
                  },
                    width: { size: 10.75, type: WidthType.PERCENTAGE }
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "O/V 2", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                    fill: "a6a6a6" 
                  },
                    width: { size: 10.75, type: WidthType.PERCENTAGE }
                })
            ]
        }),
        new TableRow({
            children: [
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "ANSI Code", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: { fill: "a6a6a6" }
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('O/C 1', 'ANSI Code'), font: "Courier New" })] })],
                    borders: tableBorders,
                    
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('O/C 2', 'ANSI Code'), font: "Courier New" })] })],
                    borders: tableBorders,
                   
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('E/F 1', 'ANSI Code'), font: "Courier New" })] })],
                    borders: tableBorders,
                  
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('E/F 2', 'ANSI Code'), font: "Courier New" })] })],
                    borders: tableBorders,
                    
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('U/V 1', 'ANSI Code'), font: "Courier New" })] })],
                    borders: tableBorders,
                   
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('U/V 2', 'ANSI Code'), font: "Courier New" })] })],
                    borders: tableBorders,
                   
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('O/V 1', 'ANSI Code'), font: "Courier New" })] })],
                    borders: tableBorders,
                  
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('O/V 2', 'ANSI Code'), font: "Courier New" })] })],
                    borders: tableBorders,
                   
                })
            ]
        }),
        new TableRow({
            children: [
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Set Value", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: { fill: "a6a6a6" }
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('O/C 1', 'Set Value'), font: "Courier New" })] })],
                    borders: tableBorders,
                  
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('O/C 2', 'Set Value'), font: "Courier New" })] })],
                    borders: tableBorders,
                  
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('E/F 1', 'Set Value'), font: "Courier New" })] })],
                    borders: tableBorders,
                 
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('E/F 2', 'Set Value'), font: "Courier New" })] })],
                    borders: tableBorders,
                   
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('U/V 1', 'Set Value'), font: "Courier New" })] })],
                    borders: tableBorders,
                  
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('U/V 2', 'Set Value'), font: "Courier New" })] })],
                    borders: tableBorders,
                   
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('O/V 1', 'Set Value'), font: "Courier New" })] })],
                    borders: tableBorders,
                  
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('O/V 2', 'Set Value'), font: "Courier New" })] })],
                    borders: tableBorders,
                    
                })
            ]
        }),
        new TableRow({
            children: [
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Curve Type", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: { fill: "a6a6a6" }
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('O/C 1', 'Curve Type'), font: "Courier New" })] })],
                    borders: tableBorders,
                  
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('O/C 2', 'Curve Type'), font: "Courier New" })] })],
                    borders: tableBorders,
                   
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('E/F 1', 'Curve Type'), font: "Courier New" })] })],
                    borders: tableBorders,
                  
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('E/F 2', 'Curve Type'), font: "Courier New" })] })],
                    borders: tableBorders,
                   
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('U/V 1', 'Curve Type'), font: "Courier New" })] })],
                    borders: tableBorders,
                 
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('U/V 2', 'Curve Type'), font: "Courier New" })] })],
                    borders: tableBorders,
                   
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('O/V 1', 'Curve Type'), font: "Courier New" })] })],
                    borders: tableBorders,
                   
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('O/V 2', 'Curve Type'), font: "Courier New" })] })],
                    borders: tableBorders,
                    
                })
            ]
        }),
        new TableRow({
            children: [
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "TIME", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: { fill: "a6a6a6" }
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('O/C 1', 'TIME'), font: "Courier New" })] })],
                    borders: tableBorders
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('O/C 2', 'TIME'), font: "Courier New" })] })],
                    borders: tableBorders
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('E/F 1', 'TIME'), font: "Courier New" })] })],
                    borders: tableBorders
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('E/F 2', 'TIME'), font: "Courier New" })] })],
                    borders: tableBorders
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('U/V 1', 'TIME'), font: "Courier New" })] })],
                    borders: tableBorders
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('U/V 2', 'TIME'), font: "Courier New" })] })],
                    borders: tableBorders
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('O/V 1', 'TIME'), font: "Courier New" })] })],
                    borders: tableBorders
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('O/V 2', 'TIME'), font: "Courier New" })] })],
                    borders: tableBorders
                })
            ]
        })
    ]
})
);

documentSections.push(new Paragraph({ text: "" })); 


documentSections.push(
    new Paragraph({
        children: [
            new TextRun({
                text: "OPERATIONAL TIME DATA",
                font: "Courier New",
                bold: true,
                size: 24
            })
        ]
    })
);

documentSections.push(new Paragraph({ text: "" })); 


documentSections.push(
    new Table({
        width: { size: 100, type: WidthType.PERCENTAGE },
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Reference", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        width: { size: 16.67, type: WidthType.PERCENTAGE },
                        shading: { fill: "a6a6a6" }
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Phase", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: {
                    fill: "a6a6a6" 
                  },
                        width: { size: 16.67, type: WidthType.PERCENTAGE }
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Set Current(A)", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: {
                    fill: "a6a6a6" 
                  },
                        width: { size: 16.67, type: WidthType.PERCENTAGE }
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Set Time(mSec)", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: {
                    fill: "a6a6a6" 
                  },
                        width: { size: 16.67, type: WidthType.PERCENTAGE }
                    }),
                     new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Injected Current(A)", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: {
                    fill: "a6a6a6" 
                  },
                        width: { size: 16.67, type: WidthType.PERCENTAGE }
                    }),
                   
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Operated Time(Sec)", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: {
                    fill: "a6a6a6" 
                  },
                        width: { size: 16.67, type: WidthType.PERCENTAGE }
                    })
                ]
            }),
          
            new TableRow({
                children: [
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "O/C 1", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: { fill: "a6a6a6" },
                        verticalAlign: VerticalAlign.CENTER
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "R", font: "Courier New" })] })],
                        borders: tableBorders
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataOC1, ['setCurrent', 'current'], 'R')), font: "Courier New" })] })],
                        borders: tableBorders
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataOC1, ['setTime', 'time', 'tms'], 'R')), font: "Courier New" })] })],
                        borders: tableBorders
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataOC1, ['injected', 'injectedCurrent', 'inject'], 'R')), font: "Courier New" })] })],
                        borders: tableBorders
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataOC1, ['operated', 'operatedTime', 'opTime'], 'R')), font: "Courier New" })] })],
                        borders: tableBorders
                    })
                ]
            }),
         
            new TableRow({
                children: [
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " ", font: "Courier New" })] })],
                        borders: tableBorders,
                        shading: { fill: "a6a6a6" }
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Y", font: "Courier New" })] })],
                        borders: tableBorders
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataOC1, ['setCurrent', 'current'], 'Y')), font: "Courier New" })] })],
                        borders: tableBorders
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataOC1, ['setTime', 'time', 'tms'], 'Y')), font: "Courier New" })] })],
                        borders: tableBorders
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataOC1, ['injected', 'injectedCurrent', 'inject'], 'Y')), font: "Courier New" })] })],
                        borders: tableBorders
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataOC1, ['operated', 'operatedTime', 'opTime'], 'Y')), font: "Courier New" })] })],
                        borders: tableBorders
                    })
                ]
            }),
            
            new TableRow({
                children: [
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " ", font: "Courier New" })] })],
                        borders: tableBorders,
                        
                        shading: { fill: "a6a6a6" }
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "B", font: "Courier New" })] })],
                        borders: tableBorders
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataOC1, ['setCurrent', 'current'], 'B')), font: "Courier New" })] })],
                        borders: tableBorders
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataOC1, ['setTime', 'time', 'tms'], 'B')), font: "Courier New" })] })],
                        borders: tableBorders
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataOC1, ['injected', 'injectedCurrent', 'inject'], 'B')), font: "Courier New" })] })],
                        borders: tableBorders
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataOC1, ['operated', 'operatedTime', 'opTime'], 'B')), font: "Courier New" })] })],
                        borders: tableBorders
                    })
                ]
            })
        ]
    })
);

documentSections.push(new Paragraph({ text: "" })); 


documentSections.push(
    new Table({
        width: { size: 100, type: WidthType.PERCENTAGE },
        rows: [
            
            new TableRow({
                children: [
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Reference", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        rowSpan: 2,
                        shading: { fill: "a6a6a6" }
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Phase", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: {
                    fill: "a6a6a6" 
                  },
                        rowSpan: 2
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Set Current(A)", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: {
                    fill: "a6a6a6" 
                  },
                        rowSpan: 2
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "TMS", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: {
                    fill: "a6a6a6" 
                  },
                        rowSpan: 2
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Injected Current(A)", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: {
                    fill: "a6a6a6" 
                  },
                        columnSpan: 3
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Operated Time(Sec)", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: {
                    fill: "a6a6a6" 
                  },
                        columnSpan: 3
                    })
                ]
            }),
           
new TableRow({
  children: [
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "2X", font: "Courier New", bold: true })] })],
      borders: tableBorders,
      shading: {
                    fill: "a6a6a6" 
                  },
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "5X", font: "Courier New", bold: true })] })],
      borders: tableBorders,
      shading: {
                    fill: "a6a6a6" 
                  },

    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "10X", font: "Courier New", bold: true })] })],
      borders: tableBorders,
      shading: {
                    fill: "a6a6a6" 
                  },
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "2X", font: "Courier New", bold: true })] })],
      borders: tableBorders,
      shading: {
                    fill: "a6a6a6" 
                  },
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "5X", font: "Courier New", bold: true })] })],
      borders: tableBorders,
      shading: {
                    fill: "a6a6a6" 
                  },
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "10X", font: "Courier New", bold: true })] })],
      borders: tableBorders,
      shading: {
                    fill: "a6a6a6" 
                  },
    })
  ]
}),

new TableRow({
  children: [
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "O/C 2", font: "Courier New", bold: true })] })],
      borders: tableBorders,
      shading: {
                    fill: "a6a6a6" 
                  },
      rowSpan: 3
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "R", font: "Courier New" })] })],
      borders: tableBorders,
      
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataOC2, ['setCurrent', 'current'], 'R')), font: "Courier New" })] })],
      borders: tableBorders
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataOC2, ['tms', 'TMS', 'time'], 'R')), font: "Courier New" })] })],
      borders: tableBorders
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getInjectedFromIndex(sectionDataOC2, 'R', '2X')), font: "Courier New" })] })],
      borders: tableBorders
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getInjectedFromIndex(sectionDataOC2, 'R', '5X')), font: "Courier New" })] })],
      borders: tableBorders
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getInjectedFromIndex(sectionDataOC2, 'R', '10X')), font: "Courier New" })] })],
      borders: tableBorders
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getOperatedFromIndex(sectionDataOC2, 'R', '2X')), font: "Courier New" })] })],
      borders: tableBorders
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getOperatedFromIndex(sectionDataOC2, 'R', '5X')), font: "Courier New" })] })],
      borders: tableBorders
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getOperatedFromIndex(sectionDataOC2, 'R', '10X')), font: "Courier New" })] })],
      borders: tableBorders
    })
  ]
}),

new TableRow({
  children: [
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Y", font: "Courier New" })] })],
      borders: tableBorders
      
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataOC2, ['setCurrent', 'current'], 'Y')), font: "Courier New" })] })],
      borders: tableBorders
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataOC2, ['tms', 'TMS', 'time'], 'Y')), font: "Courier New" })] })],
      borders: tableBorders
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getInjectedFromIndex(sectionDataOC2, 'Y', '2X')), font: "Courier New" })] })],
      borders: tableBorders
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getInjectedFromIndex(sectionDataOC2, 'Y', '5X')), font: "Courier New" })] })],
      borders: tableBorders
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getInjectedFromIndex(sectionDataOC2, 'Y', '10X')), font: "Courier New" })] })],
      borders: tableBorders
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getOperatedFromIndex(sectionDataOC2, 'Y', '2X')), font: "Courier New" })] })],
      borders: tableBorders
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getOperatedFromIndex(sectionDataOC2, 'Y', '5X')), font: "Courier New" })] })],
      borders: tableBorders
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getOperatedFromIndex(sectionDataOC2, 'Y', '10X')), font: "Courier New" })] })],
      borders: tableBorders
    })
  ]
}),

new TableRow({
  children: [
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "B", font: "Courier New" })] })],
      borders: tableBorders
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataOC2, ['setCurrent', 'current'], 'B')), font: "Courier New" })] })],
      borders: tableBorders
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataOC2, ['tms', 'TMS', 'time'], 'B')), font: "Courier New" })] })],
      borders: tableBorders
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getInjectedFromIndex(sectionDataOC2, 'B', '2X')), font: "Courier New" })] })],
      borders: tableBorders
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getInjectedFromIndex(sectionDataOC2, 'B', '5X')), font: "Courier New" })] })],
      borders: tableBorders
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getInjectedFromIndex(sectionDataOC2, 'B', '10X')), font: "Courier New" })] })],
      borders: tableBorders
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getOperatedFromIndex(sectionDataOC2, 'B', '2X')), font: "Courier New" })] })],
      borders: tableBorders
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getOperatedFromIndex(sectionDataOC2, 'B', '5X')), font: "Courier New" })] })],
      borders: tableBorders
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getOperatedFromIndex(sectionDataOC2, 'B', '10X')), font: "Courier New" })] })],
      borders: tableBorders
    })
  ]
})
]
}));

documentSections.push(new Paragraph({ text: "" }));


documentSections.push(
new Table({
  width: {
    size: 100,
    type: WidthType.PERCENTAGE,
  },
  rows: [
  
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Reference", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          width: { size: 16.67, type: WidthType.PERCENTAGE },
          shading: { fill: "a6a6a6" }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Phase", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Set Current(A)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Set Time(mSec)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Injected Current(A)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Operated Time(Sec)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        })
      ]
    }),
   
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "E/F 1", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "N", font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataEF1, ['setCurrent', 'current'], 'N')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataEF1, ['setTime', 'time', 'tms'], 'N')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataEF1, ['injected', 'injectedCurrent', 'inject'], 'N')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataEF1, ['operated', 'operatedTime', 'opTime'], 'N')), font: "Courier New" })] })],
          borders: tableBorders
        })
      ]
    })
  ]
}));

documentSections.push(new Paragraph({ text: "" }));


documentSections.push(
new Table({
  width: {
    size: 100,
    type: WidthType.PERCENTAGE,
  },
  rows: [
   
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Reference", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          rowSpan: 2,
          shading: { fill: "a6a6a6" }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Phase", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          rowSpan: 2
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Set Current(A)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          rowSpan: 2
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "TMS", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          rowSpan: 2
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Injected Current(A)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          columnSpan: 3
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Operated Time(Sec)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          columnSpan: 3
        })
      ]
    }),
   
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "2X", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "5X", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "10X", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "2X", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "5X", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "10X", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
        })
      ]
    }),
   
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "E/F 2", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: { fill: "a6a6a6" }
          
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "N", font: "Courier New" })] })],
          borders: tableBorders
          
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataEF2, ['setCurrent', 'current'], 'N')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataEF2, ['tms', 'TMS', 'time'], 'N')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getInjectedFromIndex(sectionDataEF2, 'N', '2X')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getInjectedFromIndex(sectionDataEF2, 'N', '5X')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getInjectedFromIndex(sectionDataEF2, 'N', '10X')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getOperatedFromIndex(sectionDataEF2, 'N', '2X')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getOperatedFromIndex(sectionDataEF2, 'N', '5X')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getOperatedFromIndex(sectionDataEF2, 'N', '10X')), font: "Courier New" })] })],
          borders: tableBorders
        })
      ]
    })
  ]
}));

documentSections.push(new Paragraph({ text: "" }));


documentSections.push(new Table({
  width: { size: 100, type: WidthType.PERCENTAGE },
  rows: [
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Reference", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Phase", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Set Voltage(V)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Set Time(mSec)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Injected Voltage(V)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Operated Time(Sec)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        })
      ]
    }),
  
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "U/V 1", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          verticalAlign: VerticalAlign.CENTER
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "R", font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataUV1, ['setVoltage', 'voltage'], 'R')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataUV1, ['setTime', 'time', 'tms'], 'R')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataUV1, ['injected', 'injectedVoltage', 'inject'], 'R')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataUV1, ['operated', 'operatedTime', 'opTime'], 'R')), font: "Courier New" })] })],
          borders: tableBorders
        })
      ]
    }),
   
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "", font: "Courier New" })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  }
        }),
        new TableCell({
          children: [new Paragraph({alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Y", font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataUV1, ['setVoltage', 'voltage'], 'Y')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataUV1, ['setTime', 'time', 'tms'], 'Y')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataUV1, ['injected', 'injectedVoltage', 'inject'], 'Y')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataUV1, ['operated', 'operatedTime', 'opTime'], 'Y')), font: "Courier New" })] })],
          borders: tableBorders
        })
      ]
    }),
    
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "", font: "Courier New" })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "B", font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataUV1, ['setVoltage', 'voltage'], 'B')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataUV1, ['setTime', 'time', 'tms'], 'B')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataUV1, ['injected', 'injectedVoltage', 'inject'], 'B')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataUV1, ['operated', 'operatedTime', 'opTime'], 'B')), font: "Courier New" })] })],
          borders: tableBorders
        })
      ]
    })
  ]
}));

documentSections.push(new Paragraph({ text: "" }));


documentSections.push(new Table({
  width: { size: 100, type: WidthType.PERCENTAGE },
  rows: [
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Reference", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Phase", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Set Voltage(V)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Set Time(mSec)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Injected Voltage(V)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Operated Time(Sec)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        })
      ]
    }),
   
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "U/V 2", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          verticalAlign: VerticalAlign.CENTER
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "R", font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataUV2, ['setVoltage', 'voltage'], 'R')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataUV2, ['setTime', 'time', 'tms'], 'R')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataUV2, ['injected', 'injectedVoltage', 'inject'], 'R')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataUV2, ['operated', 'operatedTime', 'opTime'], 'R')), font: "Courier New" })] })],
          borders: tableBorders
        })
      ]
    }),
    
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "", font: "Courier New" })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Y", font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataUV2, ['setVoltage', 'voltage'], 'Y')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataUV2, ['setTime', 'time', 'tms'], 'Y')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataUV2, ['injected', 'injectedVoltage', 'inject'], 'Y')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataUV2, ['operated', 'operatedTime', 'opTime'], 'Y')), font: "Courier New" })] })],
          borders: tableBorders
        })
      ]
    }),
  
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "", font: "Courier New" })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "B", font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataUV2, ['setVoltage', 'voltage'], 'B')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataUV2, ['setTime', 'time', 'tms'], 'B')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataUV2, ['injected', 'injectedVoltage', 'inject'], 'B')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataUV2, ['operated', 'operatedTime', 'opTime'], 'B')), font: "Courier New" })] })],
          borders: tableBorders
        })
      ]
    })
  ]
}));

documentSections.push(new Paragraph({ text: "" }));


documentSections.push(new Table({
  width: { size: 100, type: WidthType.PERCENTAGE },
  rows: [
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Reference", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          width: { size: 16.67, type: WidthType.PERCENTAGE },
          shading: { fill: "a6a6a6" }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Phase", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Set Voltage(V)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Set Time(mSec)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Injected Voltage(V)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Operated Time(Sec)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        })
      ]
    }),
  
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "O/V 1", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          verticalAlign: VerticalAlign.CENTER
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "R", font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV1, ['setVoltage', 'voltage'], 'R')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV1, ['setTime', 'time', 'tms'], 'R')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV1, ['injected', 'injectedVoltage', 'inject'], 'R')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV1, ['operated', 'operatedTime', 'opTime'], 'R')), font: "Courier New" })] })],
          borders: tableBorders
        })
      ]
    }),
   
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "", font: "Courier New" })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Y", font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV1, ['setVoltage', 'voltage'], 'Y')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV1, ['setTime', 'time', 'tms'], 'Y')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV1, ['injected', 'injectedVoltage', 'inject'], 'Y')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV1, ['operated', 'operatedTime', 'opTime'], 'Y')), font: "Courier New" })] })],
          borders: tableBorders
        })
      ]
    }),
  
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "", font: "Courier New" })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "B", font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV1, ['setVoltage', 'voltage'], 'B')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV1, ['setTime', 'time', 'tms'], 'B')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV1, ['injected', 'injectedVoltage', 'inject'], 'B')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV1, ['operated', 'operatedTime', 'opTime'], 'B')), font: "Courier New" })] })],
          borders: tableBorders
        })
      ]
    })
  ]
}));

documentSections.push(new Paragraph({ text: "" }));


documentSections.push(new Table({
  width: { size: 100, type: WidthType.PERCENTAGE },
  rows: [
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Reference", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          width: { size: 16.67, type: WidthType.PERCENTAGE },
          shading: { fill: "a6a6a6" }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Phase", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Set Voltage(V)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Set Time(mSec)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Injected Voltage(V)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Operated Time(Sec)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        })
      ]
    }),
   
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "O/V 2", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          verticalAlign: VerticalAlign.CENTER
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "R", font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV2, ['setVoltage', 'voltage'], 'R')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV2, ['setTime', 'time', 'tms'], 'R')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV2, ['injected', 'injectedVoltage', 'inject'], 'R')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV2, ['operated', 'operatedTime', 'opTime'], 'R')), font: "Courier New" })] })],
          borders: tableBorders
        })
      ]
    }),
  
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "", font: "Courier New" })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Y", font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV2, ['setVoltage', 'voltage'], 'Y')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV2, ['setTime', 'time', 'tms'], 'Y')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV2, ['injected', 'injectedVoltage', 'inject'], 'Y')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV2, ['operated', 'operatedTime', 'opTime'], 'Y')), font: "Courier New" })] })],
          borders: tableBorders
        })
      ]
    }),
    
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "", font: "Courier New" })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "B", font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV2, ['setVoltage', 'voltage'], 'B')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV2, ['setTime', 'time', 'tms'], 'B')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV2, ['injected', 'injectedVoltage', 'inject'], 'B')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV2, ['operated', 'operatedTime', 'opTime'], 'B')), font: "Courier New" })] })],
          borders: tableBorders
        })
      ]
    })
  ]
}));


documentSections.push(new Paragraph({ text: "" }));



documentSections.push(new Paragraph({
  children: [
    new TextRun({
      text: "FUNCTIONAL CHECKS",
      bold: true,
      size: 24,
      font: "Courier New"
    })
  ],
  alignment: AlignmentType.LEFT,
  spacing: { after: 200 }
}));


documentSections.push(new Table({
  width: {
    size: 100,
    type: WidthType.PERCENTAGE
  },
  rows: [
 
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({alignment: AlignmentType.CENTER, 
            children: [new TextRun({ text: "Check", bold: true, font: "Courier New" })],
            
          })],
          borders: tableBorders,
          width: { size: 70, type: WidthType.PERCENTAGE },
          shading: { fill: "a6a6a6" }
        }),
        new TableCell({
          children: [new Paragraph({alignment: AlignmentType.CENTER, 
            children: [new TextRun({ text: "Status", bold: true, font: "Courier New" })],
              shading: {
              fill: "a6a6a6" 
            }
          })],
          borders: tableBorders,
          width: { size: 30, type: WidthType.PERCENTAGE }
        })
      ]
    }),
    
   
    ...functionalChecksData.map((check, index) => 
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: check, font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
                    fill: "a6a6a6" 
                  }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: functionalValues[index] || "N/A", font: "Courier New" })] })],
            borders: tableBorders
          })
        ]
      })
    )
  ]
}));


documentSections.push(new Paragraph({ text: "" }));



documentSections.push(new Paragraph({
  children: [
    new TextRun({
      text: "CHECK LIST",
      bold: true,
      size: 24,
      font: "Courier New"
    })
  ],
  alignment: AlignmentType.LEFT,
  spacing: { after: 200 }
}));


documentSections.push(new Table({
  width: {
    size: 100,
    type: WidthType.PERCENTAGE
  },
  rows: [
   
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({
            children: [new TextRun({ text: "Check Point", bold: true, font: "Courier New" })],
            alignment: AlignmentType.CENTER
          })],
          borders: tableBorders,
          width: { size: 70, type: WidthType.PERCENTAGE },
          shading: { fill: "a6a6a6" }
        }),
        new TableCell({
          children: [new Paragraph({
            children: [new TextRun({ text: "Status", bold: true, font: "Courier New" })],
            alignment: AlignmentType.CENTER
          })],
            shading: {
              fill: "a6a6a6" 
            },
          borders: tableBorders,
          width: { size: 30, type: WidthType.PERCENTAGE },
         
        })
      ]
    }),
    
   
    ...checkListData.map((check, index) => 
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: check, font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
                    fill: "a6a6a6" 
                  }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: checkListValues[index] || "N/A", font: "Courier New" })] })],
            borders: tableBorders
          })
        ]
      })
    )
  ]
}));


documentSections.push(new Paragraph({ text: "" }));
documentSections.push(new Paragraph({ text: "" })); 

    const convertInchesToTwip = (inches) => {
                    return Math.round(inches * 1440);
                  };
          
                
const footerTable = new Table({
  width: { size: 100, type: WidthType.PERCENTAGE, },
  alignment: AlignmentType.LEFT,
  rows: [
    new TableRow({
      height: { value: convertInchesToTwip(0.5), rule: HeightRule.ATLEAST },
      children: [
        new TableCell({
          children: [
            new Paragraph({
              alignment: AlignmentType.LEFT,
              spacing: { before: 0, after: 0 },
              children: [
                new TextRun({
                  text: "Pie Power",
                  font: "Courier New",
                  bold: true,
                  size: 18
                })
              ]
            }),
          ],
          borders: tableBorders,
          width: { size: 25, type: WidthType.PERCENTAGE },
          verticalAlign: VerticalAlign.TOP,
          margins: {
            top: convertInchesToTwip(0.1),
            bottom: convertInchesToTwip(0.25),
            left: convertInchesToTwip(0.25),
            right: convertInchesToTwip(0.25)
          }
        }),
        new TableCell({
          children: [
            new Paragraph({
              alignment: AlignmentType.LEFT,
              spacing: { before: 0, after: 0 },
              children: [
                new TextRun({
                  text: "TPREL",
                  font: "Courier New",
                  bold: true,
                  size: 18
                })
              ]
            }),
          ],
          borders: tableBorders,
          width: { size: 25, type: WidthType.PERCENTAGE },
          verticalAlign: VerticalAlign.TOP,
          margins: {
            top: convertInchesToTwip(0.1),
            bottom: convertInchesToTwip(0.25),
            left: convertInchesToTwip(0.25),
            right: convertInchesToTwip(0.25)
          }
        }),
        new TableCell({
          children: [
            new Paragraph({
              alignment: AlignmentType.LEFT,
              spacing: { before: 0, after: 0 },
              children: [
                new TextRun({
                  text: "TPREL",
                  font: "Courier New",
                  bold: true,
                  size: 18
                })
              ]
            }),
          ],
          borders: tableBorders,
          width: { size: 25, type: WidthType.PERCENTAGE },
          verticalAlign: VerticalAlign.TOP,
          margins: {
            top: convertInchesToTwip(0.1),
            bottom: convertInchesToTwip(0.25),
            left: convertInchesToTwip(0.25),
            right: convertInchesToTwip(0.25)
          }
        }),
        new TableCell({
          children: [
            new Paragraph({
              alignment: AlignmentType.LEFT,
              spacing: { before: 0, after: 0 },
              children: [
                new TextRun({
                  text: "TPREL",
                  font: "Courier New",
                  bold: true,
                  size: 18
                }),
                new SimpleField({
                  instruction: "PAGE",
                  children: [
                    new TextRun({
                      text: "1",
                      font: "Courier New",
                      size: 16
                    })
                  ]
                }),
                new SimpleField({
                  instruction: "NUMPAGES",
                  children: [
                    new TextRun({
                      text: "1",
                      font: "Courier New",
                      size: 16
                    })
                  ]
                })
              ]
            }),
          ],
          borders: tableBorders,
          width: { size: 25, type: WidthType.PERCENTAGE },
          verticalAlign: VerticalAlign.TOP,
          margins: {
            top: convertInchesToTwip(0.1),
            bottom: convertInchesToTwip(0.25),
            left: convertInchesToTwip(0.25),
            right: convertInchesToTwip(0.25)
          }
        })
      ]
    })
  ]
});
        const pageBorders = {
  pageBorderTop: {
    style: BorderStyle.DOUBLE,
    size: 6,
    color: "000000",
    space: 3
  },


  pageBorderRight: {
    style: BorderStyle.DOUBLE,
    size: 6,
    color: "000000",
    space: 3
  },
  pageBorderBottom: {
    style: BorderStyle.DOUBLE,
    size: 6,
    color: "000000",
    space: 3
  },
  pageBorderLeft: {
    style: BorderStyle.DOUBLE,
    size: 6,
    color: "000000",
    space: 3
  }
};

      const doc = new Document({
  sections: [
    {
      properties: {
        page: {
          margin: {
            top: convertInchesToTwip(0.5),
            right: convertInchesToTwip(0.5),
            bottom: convertInchesToTwip(1.0),
            left: convertInchesToTwip(0.5)
          },
          borders: pageBorders,
          pageNumbers: {
            start: 1,
            formatType: NumberFormat.DECIMAL
          }
        }
      },
      footers: {
        default: new Footer({
          children: [
            footerTable,
            new Paragraph({
              children: [
                new TextRun({
                  text: "Page ",
                  font: "Courier New",
                  size: 16
                }),
                new TextRun({
                  children: [PageNumber.CURRENT],
                  font: "Courier New",
                  size: 16
                }),
                new TextRun({
                    text: " of ",
                    font: "Courier New",
                    size: 16
                  }),
               
                new TextRun({
                  children: [PageNumber.TOTAL_PAGES],
                  font: "Courier New",
                  size: 16
                })
              ],
              alignment: AlignmentType.CENTER,
              spacing: {
                before: 200
              }
            })
          ]
        })
      },
      headers: lightWatermarkBase64 ? {
        default: new Header({
          children: [
            new Paragraph({
              children: [
                new ImageRun({
                  data: lightWatermarkBase64,
                  transformation: {
                    width: 500,
                    height: 500
                  },
                  floating: {
                    horizontalPosition: {
                      relative: HorizontalPositionRelativeFrom.PAGE,
                      align: HorizontalPositionAlign.CENTER
                    },
                    verticalPosition: {
                      relative: VerticalPositionRelativeFrom.PAGE,
                      align: VerticalPositionAlign.CENTER
                    },
                    wrap: {
                      type: TextWrappingType.BEHIND_TEXT
                    },
                    allowOverlap: true,
                    behindDocument: true
                  }
                })
              ]
            })
          ]
        })
      } : undefined,
      children: documentSections
    }
  ]
});
          
                 
                  Packer.toBlob(doc).then(blob => {
                    resolve(blob);
                  }).catch(error => {
                 
                    reject(error);
                  });
                  });
          
                }).catch(error => {
              
                  reject(error);
                });
          
              } catch (error) {
               
                reject(error);
              }
            });
          };
   


const handleDownloadWordDoc = async () => {
  setIsLoading(true);
  setErrorMessage("");
  
  try {
    const allFormData = JSON.parse(localStorage.getItem('relaysCTFormData') || '{}');
    const safeFormData = formData && typeof formData === 'object' ? formData : allFormData;
    
    const wordBlob = await generateWordBlob(safeFormData, checkListValues);
    saveAs(wordBlob, 'RelaysCT_Inspection_Report.docx');
    
    localStorage.setItem('wordDocDownloadStatus', 'completed');
    localStorage.setItem('reportCreationCompleted', 'true');
    localStorage.setItem('lastCompletionTimestamp', Date.now().toString());
    setWordDocDownloaded(true);
    
    alert("Word document downloaded successfully.");
    
    clearAllStorageData();
    
    
  } catch (error) {
   
    setErrorMessage(`Error generating Word document: ${error.message}`);
  } finally {
    setIsLoading(false);
  }
};


  const handleBack = () => {
    setShowBackPage(true);
  };
  
  if (showBackPage) {
    return <RelaysCTThree 
      goBack={() => setShowBackPage(false)} 
      savedGeneralData={allFormData}
    />;
  }

  return (
    <div className="rt-9107">
      <div className="rt-9107-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2>FUNCTIONAL CHECKS</h2>
        
        <span 
          style={{ 
            display: 'flex',
            justifyContent: 'flex-end',
            fontSize: '20px', 
            fontWeight: '600', 
            color: '#333', 
            cursor: 'pointer',
            marginLeft: '10px',
            marginBottom: '50px'
          }}
          onClick={redirectToHome}
        >
          X
        </span>
      </div>
      
      {errorMessage && (
        <div className="rt-9107-error-message" style={{ 
          backgroundColor: '#ffebee', 
          color: '#c62828', 
          padding: '10px', 
          borderRadius: '4px', 
          marginBottom: '15px' 
        }}>
          {errorMessage}
        </div>
      )}

      {successMessage && (
        <div className="rt-9107-success-message" style={{ 
          backgroundColor: '#e8f5e8', 
          color: '#2e7d32', 
          padding: '10px', 
          borderRadius: '4px', 
          marginBottom: '15px' 
        }}>
          {successMessage}
        </div>
      )}

      <div className="rt-9107-checks-section">
        {functionalChecksData.map((item, index) => (
          <div className="rt-9107-check-row" key={`func-${index}`}>
            <div className="rt-9107-check-label">{item}</div>
            <div className="rt-9107-check-input">
              <select 
                value={functionalValues[index] || ''} 
                onChange={(e) => handleFunctionalChange(index, e.target.value)}
                disabled={hasCompletedFullFlow() || isLoading}
                style={{
                  opacity: hasCompletedFullFlow() ? 0.6 : 1,
                  cursor: hasCompletedFullFlow() ? 'not-allowed' : 'pointer'
                }}
                   >
                <option value="">Select</option>
                <option value="OK">OK</option>
                <option value="Not OK">Not OK</option>
              </select>
            </div>
          </div>
        ))}
      </div>

      <div className="rt-9107-header">
        <h2>CHECK LIST</h2>
      </div>

      <div className="rt-9107-check-point-label">Check Point</div>

       <div className="rt-9107-checks-section">
        {checkListData.map((item, index) => (
          <div className="rt-9107-check-row" key={`list-${index}`}>
            <div className="rt-9107-check-label">{item}</div>
            <div className="rt-9107-check-input">
              <select 
                value={checkListValues[index] || ''} 
                onChange={(e) => handleCheckListChange(index, e.target.value)}
                disabled={hasCompletedFullFlow()}
              >
                <option value="">Select</option>
                <option value="OK">OK</option>
                <option value="Not OK">Not OK</option>
              </select>
            </div>
          </div>
        ))}
      </div>

      <div className="rt-9107-button-container">
        <button type="button" onClick={handleBack} className="rt-9107-back-button" disabled={isLoading || hasCompletedFullFlow()}>
          Back
        </button>
        <button type="button" className="rt-9107-save-button" onClick={handleSave} disabled={isLoading || hasCompletedFullFlow()}>
          {isLoading ? "Processing..." : "Submit"}
        </button>
        
        {formSubmitted && (
          <button 
            type="button"
            className="rt-9107-download-button" 
            onClick={handleDownloadWordDoc}
            disabled={isLoading || wordDocDownloaded}
            style={{ 
              marginLeft: '10px', 
              backgroundColor: wordDocDownloaded ? '#cccccc' : '#4CAF50', 
              cursor: (isLoading || wordDocDownloaded) ? 'not-allowed' : 'pointer' 
            }}
          >
            {wordDocDownloaded ? "Downloaded" : (isLoading ? "Generating..." : "Download Word")}
          </button>
        )}
      </div>
    </div>
  );
}

export default RelaysCTFour;


